import actions from "./action";

const initialState = {
  permissions: [],
};

export default function Permissions(state = initialState, action) {
  switch (action.type) {
    case actions.SET_FEATURES:
      return {
        ...state,
        permissions: action.payload,
      };

    default:
      return state;
  }
}
